import React from 'react';

// Skeleton para una tarjeta de tarea individual
const TaskCardSkeleton = () => (
  <div className="ui-task-skeleton-card">
    <div className="ui-task-skeleton-indicator"></div>
    <div className="ui-task-skeleton-content">
      {/* Header con contador y acciones */}
      <div className="ui-task-skeleton-header">
        <div className="ui-task-skeleton-badge"></div>
        <div className="ui-task-skeleton-actions">
          <div className="ui-task-skeleton-action"></div>
          <div className="ui-task-skeleton-action"></div>
        </div>
      </div>

      {/* Titulo */}
      <div className="ui-task-skeleton-title"></div>
      <div className="ui-task-skeleton-title-short"></div>

      {/* Labels */}
      <div className="ui-task-skeleton-labels">
        <div className="ui-task-skeleton-label"></div>
        <div className="ui-task-skeleton-label" style={{ width: '60px' }}></div>
      </div>

      {/* Fecha */}
      <div className="ui-task-skeleton-date"></div>

      {/* Footer con iconos y avatares */}
      <div className="ui-task-skeleton-footer">
        <div className="ui-task-skeleton-icons">
          <div className="ui-task-skeleton-icon"></div>
          <div className="ui-task-skeleton-icon"></div>
        </div>
        <div className="ui-task-skeleton-avatars">
          <div className="ui-task-skeleton-avatar"></div>
          <div className="ui-task-skeleton-avatar ui-task-skeleton-avatar-owner"></div>
        </div>
      </div>
    </div>
  </div>
);

// Skeleton para una columna completa
const ColumnSkeleton = ({ tasksCount = 3 }) => (
  <div className="ui-column-skeleton">
    {/* Header de columna */}
    <div className="ui-column-skeleton-header">
      <div className="ui-column-skeleton-title"></div>
      <div className="ui-column-skeleton-count"></div>
    </div>

    {/* Tarjetas skeleton */}
    <div className="ui-column-skeleton-body">
      {[...Array(tasksCount)].map((_, index) => (
        <TaskCardSkeleton key={index} />
      ))}
    </div>
  </div>
);

// Skeleton para el tablero completo
const BoardSkeleton = ({ columnsCount = 4, tasksPerColumn = 3 }) => (
  <div className="ui-board-skeleton">
    {[...Array(columnsCount)].map((_, index) => (
      <ColumnSkeleton key={index} tasksCount={tasksPerColumn} />
    ))}
  </div>
);

export { TaskCardSkeleton, ColumnSkeleton, BoardSkeleton };
export default BoardSkeleton;
